import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) { setError(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" sub="Enter your email and we'll send a reset link."
      footer={<Link to="/login" className="text-[#B87333] font-medium hover:underline" data-testid="back-to-signin">Back to sign in</Link>}>
      {done ? (
        <p className="text-[#2C2621]" data-testid="forgot-done">If that email is registered, a reset link has been sent. Please check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <label className="text-sm font-medium text-[#2C2621]">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading} className={btnCls} data-testid="forgot-submit">{loading ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
    </AuthShell>
  );
}
